module.exports = __webpack_public_path__ + "media/theme/2 open-2c31dc09.png";